import { render, staticRenderFns } from "./parkpassage.vue?vue&type=template&id=08dcb178&"
import script from "./parkpassage.vue?vue&type=script&lang=js&"
export * from "./parkpassage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports